import { SoilP2O5Method } from "../generated/enums"
import { ISoilAnalysis, SoilUnit } from "../soil"
import { isNumber } from "../utils/utils"
import { getMorganAttribute, MorganAttribute } from "./morgan"

export const conversions = {

    P2O5: {
        toMorgan: (value: number) => roundMorganP2O5(Math.pow(value / 6.6144, 1 / 0.5451)),
        toOlsen: (value: number) => round(Math.pow(value, 0.5451) * 6.6144)
    },

    K2O: {
        toMorgan: (value: number) => round(Math.pow(value / 3.4995, 1 / 0.7968)),
        toOlsen: (value: number) => round(Math.pow(value, 0.7968) * 3.4995)
    },

    MgO: {
        toMorgan: (value: number) => round(Math.pow(value / 4.4394, 1 / 0.5888)),
        toOlsen: (value: number) => round(Math.pow(value, 0.5888) * 4.4394)
    },

} as const

export function convertMorganToOlsen(attr: MorganAttribute, mgl: number) {
    return conversions[attr].toOlsen(mgl)
}

export function convertOlsenToMorgan(attr: MorganAttribute, mgl: number) {
    return conversions[attr].toMorgan(mgl)
}


export function convertAnalysisAttributeToUnit(sa: ISoilAnalysis, attr: string, units: SoilUnit) {

    let value = sa[attr] as number

    const morgan = getMorganAttribute(attr)

    if (morgan) {

        const isMorgan = sa.P2O5Method === SoilP2O5Method.Morgan

        if ((units === SoilUnit.Morgan) && (!isMorgan)) {
            value = convertOlsenToMorgan(morgan, value)
        }
        else if ((units === SoilUnit.Ppm) && (isMorgan)) {
            value = convertMorganToOlsen(morgan, value)
        }


    }

    return value

}

function roundMorganP2O5(value: number) {

    if (Number.isNaN(value)) {
        return undefined
    }

    if (isNumber(value)) {
        const dp = (value < 30) ? 10 : 1
        value = Math.round(value * dp) / dp
    }

    return value

}

function round(value: number) {

    if (Number.isNaN(value)) {
        return undefined
    }

    return isNumber(value)
        ? Math.round(value)
        : value

}
